import React from "react";
import Popup from "reactjs-popup";
const PopupComponent = (props) => {
  return (
    <Popup
      open={props.open}
      contentStyle={{
        padding: "1.5rem",
        backgroundColor: "white",
        borderRadius: 4,
        width: props.width ? props.width : 450,
        height: props.height ? props.height : "auto",
      }}
      overlayStyle={{
        backgroundColor: "#00000080",
      }}
      closeOnDocumentClick={false}
    >
      {props.children}
    </Popup>
  );
};

export default PopupComponent;
